import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { FormattedMessage } from 'react-intl';
import { compose } from 'react-apollo';

import s from './Contact.css';
import cs from '../../commonStyle.css';

import messages from '../../../locale/messages';
import { LANDING_CONTACT_SUPPORT_EMAIL } from '../landingContent';
import LandingContactForm from './LandingContactForm';

class Contact extends React.Component {
  render() {
    return (
      <section id="contact" className={s.contactSection}>
        <div className={s.contactWrapper}>
          <div className={s.contactLeft}>
            <span className={s.contactOverline}>
              <FormattedMessage {...messages.newLandingContact} />
            </span>
            <h2><FormattedMessage {...messages.newLandingQuestionsHeading} /></h2>
            <LandingContactForm />
          </div>

          <div className={s.contactRight}>
            <div className={s.contactMap}>
              <div className={s.mapBg} />
              {/* Morocco only (USA map marker removed) */}
              <div className={`${s.mapPointWrapper} ${s.moroccoLocation}`}>
                <div className={s.mapPoint} />
                <div className={s.mapLabel}>
                  <FormattedMessage {...messages.newLandingMoroccoLabel} />
                </div>
              </div>
            </div>

            <div className={s.contactActions}>
              <a
                href={`mailto:${LANDING_CONTACT_SUPPORT_EMAIL}`}
                className={s.contactPill}
                dir="ltr"
              >
                {LANDING_CONTACT_SUPPORT_EMAIL}
              </a>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default compose(
  withStyles(s, cs),
)(Contact);
